var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.872,
    height: 42.872,
    viewBox: "0 0 42.872 42.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 42.872,
    height: 42.872,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M25.68,39.389a.644.644,0,0,1-.454-.187L12.512,26.485a.641.641,0,0,1,.907-.907L25.68,37.84,37.84,25.682,25.579,13.418a.641.641,0,0,1,.907-.907L39.2,25.228a.639.639,0,0,1,0,.907L26.134,39.2a.644.644,0,0,1-.454.187",
    transform: "translate(3.484 3.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M26.16,35.513a.646.646,0,0,1-.454-.187L11.443,21.065a.643.643,0,0,1,0-.908l8.716-8.715a.659.659,0,0,1,.907,0L35.327,25.7a.642.642,0,0,1,0,.907l-8.715,8.716a.645.645,0,0,1-.453.187M12.8,20.61,26.16,33.964l7.808-7.808L20.612,12.8Z",
    transform: "translate(3.182 3.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M16.775,21.68a.64.64,0,0,1-.454-.187L2.058,7.232a.643.643,0,0,1,0-.908L6.327,2.058a.657.657,0,0,1,.906,0L21.494,16.32a.639.639,0,0,1,0,.907l-4.265,4.266a.649.649,0,0,1-.454.187M3.421,6.778,16.775,20.132l3.359-3.359L6.779,3.418Z",
    transform: "translate(0.529 0.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M30.583,34.6a4.023,4.023,0,0,1-2.846-6.869,4.12,4.12,0,0,1,5.691,0A4.024,4.024,0,0,1,30.583,34.6m0-6.765a2.741,2.741,0,0,0-1.939,4.679,2.807,2.807,0,0,0,3.878,0,2.741,2.741,0,0,0-1.938-4.679",
    transform: "translate(7.507 7.516)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M3.3,6.592a3.293,3.293,0,1,1,2.333-.963A3.285,3.285,0,0,1,3.3,6.592m0-5.312a2.015,2.015,0,1,0,1.425.59A2.006,2.006,0,0,0,3.3,1.28",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M2.558,9.935A.641.641,0,0,1,2.1,8.84L8.84,2.106a.641.641,0,0,1,.907.907L3.012,9.748a.644.644,0,0,1-.454.187",
    transform: "translate(0.542 0.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M5.07,12.446a.641.641,0,0,1-.454-1.1l6.735-6.734a.641.641,0,0,1,.907.907L5.524,12.259a.644.644,0,0,1-.454.187",
    transform: "translate(1.252 1.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M7.581,14.958a.641.641,0,0,1-.454-1.1l6.735-6.735a.641.641,0,0,1,.907.907L8.035,14.771a.644.644,0,0,1-.454.187",
    transform: "translate(1.962 1.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M10.092,17.469a.641.641,0,0,1-.454-1.1l6.735-6.735a.642.642,0,0,1,.908.907l-6.735,6.737a.644.644,0,0,1-.454.187",
    transform: "translate(2.672 2.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M5.071,13.156a.664.664,0,0,1-.214-.036.642.642,0,0,1-.391-.818L7.98,2.344a.641.641,0,0,1,1.21.427L5.676,12.729a.643.643,0,0,1-.605.427",
    transform: "translate(1.252 0.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M7.582,15.668a.664.664,0,0,1-.214-.036.643.643,0,0,1-.391-.82l3.515-9.956a.641.641,0,1,1,1.21.427L8.187,15.24a.644.644,0,0,1-.605.428",
    transform: "translate(1.962 1.252)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M10.092,18.179a.664.664,0,0,1-.214-.036.644.644,0,0,1-.391-.82L13,7.367a.641.641,0,1,1,1.21.427L10.7,17.75a.642.642,0,0,1-.605.428",
    transform: "translate(2.672 1.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M12.6,20.69a.664.664,0,0,1-.214-.036.644.644,0,0,1-.391-.82l3.515-9.956a.641.641,0,1,1,1.21.427L13.21,20.261a.642.642,0,0,1-.605.428",
    transform: "translate(3.382 2.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M22.891,26.462a.644.644,0,0,1-.454-.187l-7.6-7.605a.641.641,0,0,1,.907-.907l7.6,7.6a.641.641,0,0,1-.453,1.1",
    transform: "translate(4.14 4.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M23.755,27.326a.644.644,0,0,1-.454-.187l-1.2-1.2a.641.641,0,0,1,.907-.907l1.2,1.2a.641.641,0,0,1-.454,1.1",
    transform: "translate(6.195 7.024)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.f344e54efbf9e4ccd01102fa88f002cb.svg";
export { ForwardRef as ReactComponent };